import { useCallback, useState } from 'react';

import { confirmSale as confirmSaleAction, refundSale as refundSaleAction } from 'lib/models/order';

function useInAppSalesActions() {
	const [loading, setLoading] = useState(false);

	const confirmSale = useCallback(async (id: string) => {
		setLoading(true);
		await confirmSaleAction(id);
		setLoading(false);
	}, []);

	const refundSale = useCallback(async (id: string, adminKey: string) => {
		setLoading(true);
		await refundSaleAction(id, adminKey);
		setLoading(false);
	}, []);

	return {
		loading,
		confirmSale,
		refundSale,
	};
}

export default useInAppSalesActions;
